import React, { useEffect, useState, useCallback } from 'react';
import Cookies from 'js-cookie';
import { DateTime } from 'luxon';

import AuthService from '../../utils/AuthService';

const SECURE_COOKIE =
  process.env.REACT_APP_SECURE_COOKIE! === 'true' ? true : false;

type AuthProps = {
  children: React.ReactNode;
};

const AFTER_LOGIN_REDIRECT_URL = 'redirect_url';

const checkOnline = async (): Promise<boolean> => {
  const timestamp = Math.ceil(DateTime.local().toSeconds());

  try {
    await fetch(`/favicon.ico?${timestamp}`);
  } catch {
    return false;
  }

  return true;
};

const AuthPage: React.FC<AuthProps> = ({ children }) => {
  const [authenticated, setAuthenticated] = useState(false);

  const checkAuthenticated = useCallback(async () => {
    if (AuthService.isAuthenticated()) {
      setAuthenticated(true);
    } else {
      try {
        if (await checkOnline()) {
          const refreshToken = AuthService.getRefreshToken();

          await AuthService.updateToken({
            redirectUri: `${window.location.origin}/callback`,
            refreshToken: refreshToken,
          });

          setAuthenticated(true);
        }
      } catch (e) {
        Cookies.set(AFTER_LOGIN_REDIRECT_URL, window.location.href, {
          secure: SECURE_COOKIE,
          sameSite: 'Lax',
        });

        AuthService.login({
          redirectUri: `${window.location.origin}/callback`,
        });
      }
    }

    setTimeout(checkAuthenticated, 10000);
  }, []);

  useEffect(() => {
    checkAuthenticated();
  }, [checkAuthenticated]);

  return <>{authenticated && <>{children}</>}</>;
};

export default AuthPage;
